
import { ref, computed } from 'vue'
import { defineStore } from 'pinia'
import { useUserStore } from './user'
import { useIncentivesStore } from './incentives'
import { usePerformanceStore } from './performance'
import { useActivityStore } from './activity'
import { useRatingsStore } from './ratings'
import { useBusinessPartnersStore } from './businessPartners'
import { useBusinessPartnersListsStore } from './businessPartnersLists'
import { useBusinessPartnersCountStore } from './businessPartnersCount'

export const useCampaignLoadingStore = defineStore('campaignLoading', () => {
  // Each store exposes isLoading in userStore.currentSelection
  const userStore = useUserStore();
  const incentivesStore = useIncentivesStore();
  const performanceStore = usePerformanceStore();
  const activityStore = useActivityStore();
  const ratingsStore = useRatingsStore();
  const businessPartnersStore = useBusinessPartnersStore();
  const businessPartnersListsStore = useBusinessPartnersListsStore();
  const businessPartnersCountStore = useBusinessPartnersCountStore();

  // List of loading states to track (nur booleans zählen)
  const loadingStates = computed(() => [
    userStore.currentSelection.campaign?.isLoading,
    userStore.currentSelection.incentives?.isLoading,
    userStore.currentSelection.performance?.isLoading,
    userStore.currentSelection.activity?.isLoading,
    userStore.currentSelection.ratings?.isLoading,
    userStore.currentSelection.businessPartnerList?.isLoading,
    userStore.currentSelection.businessPartnerCount?.isLoading,
    userStore.currentSelection.businessPartnersLists?.isLoading,
  ].filter(v => typeof v === 'boolean'));

  const total = computed(() => loadingStates.value.length)
  const loaded = computed(() => loadingStates.value.filter(v => v === false).length)
  const percent = computed(() => total.value === 0 ? 100 : Math.round((loaded.value / total.value) * 100))
  const visible = computed(() => loaded.value < total.value)

  return { percent, visible }
})
